import { createUniqueId, ParentComponent, splitProps } from "solid-js";
import FormControlErrors, { errorId } from "./FormControlErrors";
import FormLabel from "./FormLabel";
import { formControlProps } from "./formControl";
import { SelectAttributes } from "./Select";

const SelectFormControl: ParentComponent<
  Omit<SelectAttributes, "multiple" | "value"> & {
    value?: string | number;
    label?: any;
    errors?: false | (string | { message: string })[];
  }
> = (props) => {
  const [local, selectProps] = splitProps(props, formControlProps);
  const id = local.id ?? createUniqueId();
  const invalid = () => (local.errors || []).length > 0;
  return (
    <div class={"w-100"}>
      <FormLabel for={id}>{local.label}</FormLabel>
      <select
        {...selectProps}
        id={id}
        classList={{
          ...local.classList,
          ["form-select"]: true,
          ["is-invalid"]: invalid(),
        }}
        aria-invalid={invalid()}
        aria-error-message={invalid() && errorId(id, 0)}
      />
      <FormControlErrors for={id} errors={local.errors} />
    </div>
  );
};
export default SelectFormControl;
